import { EntityBase } from "../entity/entity.model";
import { environment } from "../../../../../environments/environment";
import { UserEntity, UserEntityBase } from "../user/user-entity.model";
import { UserBase } from "../user/user.model";
import { UserEntityProfileType } from "../user/user-entity-profile-type.model";
import { AuthorityBase } from "./authority.model";

export class ConfigBase {

    serverAddress: string = environment.serverAddress
    appletSignerServerAddress!: string
    entityHeader: string = ""

    connectedEntityDetail!: { userEntity: UserEntity; entity: EntityBase }
    connectedUser: UserBase = new UserBase()
    authorities: AuthorityBase[] = []
    entities: { userEntity: UserEntity; entity: EntityBase }[] = []

    public hasConnectedUser(): boolean {
        return this.connectedUser != null && !!this.connectedUser.id
    }

    public getEntityHeader(): string {
        return this.entityHeader
    }

    static fromConfig(config: Config): ConfigBase {
        const current = new ConfigBase()
        Object.assign(current, config)

        current.connectedEntityDetail = {
            userEntity: UserEntityBase.fromUserEntity(config.connectedEntityDetail.userEntity),
            entity: EntityBase.fromEntity(config.connectedEntityDetail.entity),
        }

        current.connectedUser = UserBase.fromUser(config.connectedUser)

        current.authorities = config.authorities.map(AuthorityBase.fromAuthority)

        current.entities = config.entities?.map(e => ({
            userEntity: UserEntityBase.fromUserEntity(e.userEntity),
            entity: EntityBase.fromEntity(e.entity)
        })) || []

        current.entities.sort((a, b) =>
            a.entity.entityInfo.name.localeCompare(b.entity.entityInfo.name)
        )

        return current
    }

    public hasAdminProfile(): boolean {
        return this.hasProfile(UserEntityProfileType.ADMIN)
    }

    public hasSupportProfile(): boolean {
        return this.hasProfile(UserEntityProfileType.SUPPORT)
    }

    public hasServiceManagerProfile(): boolean {
        return this.hasProfile(UserEntityProfileType.SERVICE_MANAGER)
    }

    public hasEnsManagerProfile(): boolean {
        return this.hasProfile(UserEntityProfileType.ENS_MANAGER)
    }

    public hasSignerProfile(): boolean {
        return this.hasProfile(UserEntityProfileType.SIGNER)
    }

    public hasUserProfile(): boolean {
        return this.hasProfile(UserEntityProfileType.USER)
    }

    private hasProfile(profile: UserEntityProfileType): boolean {
        return this.authorities.some(a => a.authority === profile)
    }

    // Don't remove, use it when u need to disable content on PRO //
    public disabledForProductionRelease(canAdmin: boolean): boolean {
        return canAdmin
            ? this.isProduction() && !this.hasAdminProfile()
            : this.isProduction()
    }

    public isProduction(): boolean {
        return window.location.hostname === "eacat3-cl.aoc.cat"
    }
}

export interface Config extends ConfigBase {

}
